var map = {
	"./AbnormalTrafficReport/en.json": 20034,
	"./AbnormalTrafficReport/ru.json": 34015,
	"./AccostLlmForm/en.json": 96133,
	"./AccostLlmForm/ru.json": 66050,
	"./AccostLlmItem/en.json": 5440,
	"./AccostLlmItem/ru.json": 58860,
	"./AccostRobot/en.json": 44681,
	"./AccostRobot/ru.json": 30744,
	"./AccountNumbersTabs/en.json": 78149,
	"./AccountNumbersTabs/ru.json": 28809,
	"./AccountingReport/en.json": 43488,
	"./AccountingReport/ru.json": 51634,
	"./AcemountMediaForm/en.json": 60323,
	"./AcemountMediaForm/ru.json": 35271,
	"./AcsForm/en.json": 29924,
	"./AcsForm/ru.json": 72748,
	"./ActionBlock/en.json": 20822,
	"./ActionBlock/ru.json": 89266,
	"./ActionConditionForm/en.json": 83639,
	"./ActionConditionForm/ru.json": 79744,
	"./ActionConditionItem/en.json": 93607,
	"./ActionConditionItem/ru.json": 36718,
	"./ActionForm/en.json": 16855,
	"./ActionForm/ru.json": 46577,
	"./ActionRobot/en.json": 11127,
	"./ActionRobot/ru.json": 84142,
	"./AddSetupCallerId/en.json": 48594,
	"./AddSetupCallerId/ru.json": 33010,
	"./AdvertSource/en.json": 95775,
	"./AdvertSource/ru.json": 29840,
	"./AdvertSources/en.json": 58378,
	"./AdvertSources/ru.json": 12895,
	"./AffiliateForm/en.json": 71046,
	"./AffiliateForm/ru.json": 1272,
	"./AiAssistant/en.json": 93706,
	"./AiAssistant/ru.json": 35920,
	"./AiAssistantAction/en.json": 97100,
	"./AiAssistantAction/ru.json": 30429,
	"./AiAssistantsList/en.json": 64619,
	"./AiAssistantsList/ru.json": 86119,
	"./AmoCrmIntegration/en.json": 63130,
	"./AmoCrmIntegration/ru.json": 28013,
	"./AndOr/en.json": 87931,
	"./AndOr/ru.json": 92743,
	"./AppointmentManagers/en.json": 4352,
	"./AppointmentManagers/ru.json": 13071,
	"./AssistantModelsSection/en.json": 51135,
	"./AssistantModelsSection/ru.json": 44590,
	"./AssistantRoleGuide/en.json": 16255,
	"./AssistantRoleGuide/ru.json": 96520,
	"./AssistantRoleModerator/en.json": 46245,
	"./AssistantRoleModerator/ru.json": 42947,
	"./AssistantSettings/en.json": 88283,
	"./AssistantSettings/ru.json": 74512,
	"./AssistantToolsSection/en.json": 50898,
	"./AssistantToolsSection/ru.json": 78992,
	"./AtsGroupBindings/en.json": 72013,
	"./AtsGroupBindings/ru.json": 69346,
	"./AtsGroupForm/en.json": 45965,
	"./AtsGroupForm/ru.json": 26122,
	"./AtsGroups/en.json": 79674,
	"./AtsGroups/ru.json": 90178,
	"./AtsHistory/en.json": 16677,
	"./AtsHistory/ru.json": 11119,
	"./AtsOrgUserForm/en.json": 35653,
	"./AtsOrgUserForm/ru.json": 36320,
	"./AtsQueueActionForm/en.json": 18591,
	"./AtsQueueActionForm/ru.json": 80849,
	"./AtsQueueActions/en.json": 86243,
	"./AtsQueueActions/ru.json": 51933,
	"./AtsQueueBindings/en.json": 51487,
	"./AtsQueueBindings/ru.json": 13353,
	"./AtsQueueForm/en.json": 46493,
	"./AtsQueueForm/ru.json": 60680,
	"./AtsQueueGroupForm/en.json": 65335,
	"./AtsQueueGroupForm/ru.json": 30846,
	"./AtsQueueGroupsList/en.json": 47328,
	"./AtsQueueGroupsList/ru.json": 37434,
	"./AtsQueueOperators/en.json": 13958,
	"./AtsQueueOperators/ru.json": 87865,
	"./AtsQueueSteps/en.json": 30897,
	"./AtsQueueSteps/ru.json": 90557,
	"./AtsQueueTrunks/en.json": 87394,
	"./AtsQueueTrunks/ru.json": 72285,
	"./AtsQueues/en.json": 12278,
	"./AtsQueues/ru.json": 40745,
	"./AtsServerForm/en.json": 85155,
	"./AtsServerForm/ru.json": 12224,
	"./AtsServers/en.json": 4297,
	"./AtsServers/ru.json": 36683,
	"./AtsSips/en.json": 93677,
	"./AtsSips/ru.json": 32415,
	"./AtsUserForm/en.json": 1714,
	"./AtsUserForm/ru.json": 57991,
	"./AtsUserHistory/en.json": 94370,
	"./AtsUserHistory/ru.json": 89688,
	"./AtsUserIndependentForm/en.json": 30455,
	"./AtsUserIndependentForm/ru.json": 4545,
	"./AtsUserPrivateForm/en.json": 70662,
	"./AtsUserPrivateForm/ru.json": 74340,
	"./AtsUsers/en.json": 65784,
	"./AtsUsers/ru.json": 75729,
	"./AtsWeightAdjusting/en.json": 50595,
	"./AtsWeightAdjusting/ru.json": 98935,
	"./AudioForm/en.json": 77423,
	"./AudioForm/ru.json": 68371,
	"./AudioPlayer/en.json": 55322,
	"./AudioPlayer/ru.json": 9937,
	"./AudioRecordTemplate/en.json": 90894,
	"./AudioRecordTemplate/ru.json": 97145,
	"./AuditOrders/en.json": 9906,
	"./AuditOrders/ru.json": 33501,
	"./AutoresponderStats/en.json": 39228,
	"./AutoresponderStats/ru.json": 16917,
	"./AverageTransitionTime/en.json": 90049,
	"./AverageTransitionTime/ru.json": 39112,
	"./BalanceList/en.json": 2714,
	"./BalanceList/ru.json": 79485,
	"./BaseEmailProviderForm/en.json": 10514,
	"./BaseEmailProviderForm/ru.json": 82526,
	"./BillingCallReport/en.json": 61871,
	"./BillingCallReport/ru.json": 58808,
	"./BillingEmailReport/en.json": 63906,
	"./BillingEmailReport/ru.json": 18368,
	"./BillingMessengerReport/en.json": 63985,
	"./BillingMessengerReport/ru.json": 8198,
	"./BillingMessengerSessionsReport/en.json": 30859,
	"./BillingMessengerSessionsReport/ru.json": 22781,
	"./BillingSmsReport/en.json": 21995,
	"./BillingSmsReport/ru.json": 15438,
	"./BillingSmsSessionsReport/en.json": 52128,
	"./BillingSmsSessionsReport/ru.json": 14591,
	"./BillingSpeechReport/en.json": 58499,
	"./BillingSpeechReport/ru.json": 9539,
	"./BitrixIntegration/en.json": 49372,
	"./BitrixIntegration/ru.json": 96352,
	"./Blacklist/en.json": 22076,
	"./Blacklist/ru.json": 58918,
	"./BlacklistHeader/en.json": 44662,
	"./BlacklistHeader/ru.json": 94357,
	"./BlacklistTable/en.json": 70676,
	"./BlacklistTable/ru.json": 64375,
	"./BlockButtonCellTemplate/en.json": 53977,
	"./BlockButtonCellTemplate/ru.json": 82207,
	"./BoomerangPOneSmsForm/en.json": 74686,
	"./BoomerangPOneSmsForm/ru.json": 80200,
	"./BotBindings/en.json": 8476,
	"./BotBindings/ru.json": 56940,
	"./BotCampaignAnalytics/en.json": 1513,
	"./BotCampaignAnalytics/ru.json": 59153,
	"./BotCampaignAnalyticsTable/en.json": 59265,
	"./BotCampaignAnalyticsTable/ru.json": 84101,
	"./BotCampaignDialog/en.json": 53278,
	"./BotCampaignDialog/ru.json": 25505,
	"./BotCampaignElementList/en.json": 71267,
	"./BotCampaignElementList/ru.json": 10461,
	"./BotCampaigns/en.json": 13266,
	"./BotCampaigns/ru.json": 419,
	"./BotCampaing/en.json": 70208,
	"./BotCampaing/ru.json": 92334,
	"./BotCampaingLoadingByFilter/en.json": 32780,
	"./BotCampaingLoadingByFilter/ru.json": 69187,
	"./BotCheckModal/en.json": 83022,
	"./BotCheckModal/ru.json": 44951,
	"./BotScriptCard/en.json": 98728,
	"./BotScriptCard/ru.json": 72269,
	"./BotScriptStats/en.json": 42867,
	"./BotScriptStats/ru.json": 48707,
	"./BottoSmsForm/en.json": 38221,
	"./BottoSmsForm/ru.json": 34204,
	"./BottoSmsWhatsappForm/en.json": 72171,
	"./BottoSmsWhatsappForm/ru.json": 80325,
	"./BpErrorLogList/en.json": 6266,
	"./BpErrorLogList/ru.json": 22867,
	"./BpmAction/en.json": 3206,
	"./BpmAction/ru.json": 88935,
	"./BpmActionAtsQueue/en.json": 38209,
	"./BpmActionAtsQueue/ru.json": 90643,
	"./BpmActionForm/en.json": 40321,
	"./BpmActionForm/ru.json": 47768,
	"./BpmActionOperatorScriptsForm/en.json": 44894,
	"./BpmActionOperatorScriptsForm/ru.json": 47592,
	"./BpmActionStats/en.json": 84244,
	"./BpmActionStats/ru.json": 92754,
	"./BpmArrows/en.json": 11430,
	"./BpmArrows/ru.json": 22248,
	"./BpmAutoReport/en.json": 70465,
	"./BpmAutoReport/ru.json": 86106,
	"./BpmAutoReportNotify/en.json": 73399,
	"./BpmAutoReportNotify/ru.json": 23211,
	"./BpmBillingTabsOfReport/en.json": 35032,
	"./BpmBillingTabsOfReport/ru.json": 25847,
	"./BpmBp/en.json": 75117,
	"./BpmBp/ru.json": 16073,
	"./BpmBpAtsSetup/en.json": 37195,
	"./BpmBpAtsSetup/ru.json": 77700,
	"./BpmBpList/en.json": 22305,
	"./BpmBpList/ru.json": 32489,
	"./BpmCases/en.json": 80184,
	"./BpmCases/ru.json": 63778,
	"./BpmCheckModal/en.json": 27075,
	"./BpmCheckModal/ru.json": 87431,
	"./BpmContainer/en.json": 29758,
	"./BpmContainer/ru.json": 5882,
	"./BpmContrahen/en.json": 77137,
	"./BpmContrahen/ru.json": 64185,
	"./BpmContrahenList/en.json": 86516,
	"./BpmContrahenList/ru.json": 23406,
	"./BpmDb/en.json": 72734,
	"./BpmDb/ru.json": 91038,
	"./BpmDbList/en.json": 64498,
	"./BpmDbList/ru.json": 97792,
	"./BpmEditor/en.json": 56309,
	"./BpmEditor/ru.json": 76470,
	"./BpmErrorEmailNotice/en.json": 48727,
	"./BpmErrorEmailNotice/ru.json": 8286,
	"./BpmErrorSmsNotice/en.json": 81578,
	"./BpmErrorSmsNotice/ru.json": 47568,
	"./BpmEventForm/en.json": 29531,
	"./BpmEventForm/ru.json": 72088,
	"./BpmGatewayForm/en.json": 5762,
	"./BpmGatewayForm/ru.json": 30964,
	"./BpmHistories/en.json": 33802,
	"./BpmHistories/ru.json": 82824,
	"./BpmHistoryModal/en.json": 12207,
	"./BpmHistoryModal/ru.json": 3615,
	"./BpmJumpForm/en.json": 8780,
	"./BpmJumpForm/ru.json": 38379,
	"./BpmJumpSelector/en.json": 96918,
	"./BpmJumpSelector/ru.json": 70428,
	"./BpmParameters/en.json": 11789,
	"./BpmParameters/ru.json": 84910,
	"./BpmPlannerForm/en.json": 59911,
	"./BpmPlannerForm/ru.json": 22934,
	"./BpmSmsBeaconForm/en.json": 74554,
	"./BpmSmsBeaconForm/ru.json": 61191,
	"./BpmSmsBeacons/en.json": 4983,
	"./BpmSmsBeacons/ru.json": 83913,
	"./BpmSmsBeaconsExport/en.json": 70818,
	"./BpmSmsBeaconsExport/ru.json": 11162,
	"./BpmSmsBeaconsList/en.json": 97800,
	"./BpmSmsBeaconsList/ru.json": 57480,
	"./BpmSmsInfoPopover/en.json": 16290,
	"./BpmSmsInfoPopover/ru.json": 84634,
	"./BpmStart/en.json": 87437,
	"./BpmStart/ru.json": 52593,
	"./BpmStatsForm/en.json": 12562,
	"./BpmStatsForm/ru.json": 28754,
	"./BpmToolbar/en.json": 90572,
	"./BpmToolbar/ru.json": 26639,
	"./BpmTrash/en.json": 94114,
	"./BpmTrash/ru.json": 67866,
	"./BpmTrashActionJumpsTable/en.json": 66297,
	"./BpmTrashActionJumpsTable/ru.json": 44516,
	"./BpmTrashActionsTable/en.json": 51072,
	"./BpmTrashActionsTable/ru.json": 31324,
	"./BpmVars/en.json": 2179,
	"./BpmVars/ru.json": 27533,
	"./BsgForm/en.json": 13866,
	"./BsgForm/ru.json": 6105,
	"./BuiltInFunctionsMiniList/en.json": 68699,
	"./BuiltInFunctionsMiniList/ru.json": 27649,
	"./BulkTextForm/en.json": 42663,
	"./BulkTextForm/ru.json": 26983,
	"./BytehandForm/en.json": 54225,
	"./BytehandForm/ru.json": 81989,
	"./Calendar/en.json": 73576,
	"./Calendar/ru.json": 56537,
	"./CallCenter/en.json": 9635,
	"./CallCenter/ru.json": 55515,
	"./CallCenterCalls/en.json": 23063,
	"./CallCenterCalls/ru.json": 49725,
	"./CallCenterWagesExtendedReport/en.json": 60670,
	"./CallCenterWagesExtendedReport/ru.json": 9,
	"./CallCenterWagesExtendedReportV2/en.json": 47148,
	"./CallCenterWagesExtendedReportV2/ru.json": 35534,
	"./CallCenterWagesExtendedReportV2Setup/en.json": 13685,
	"./CallCenterWagesExtendedReportV2Setup/ru.json": 78512,
	"./CallCenterWagesTimeOnLineReport/en.json": 80865,
	"./CallCenterWagesTimeOnLineReport/ru.json": 72912,
	"./CallCenters/en.json": 90579,
	"./CallCenters/ru.json": 88122,
	"./CallTransferForm/en.json": 81799,
	"./CallTransferForm/ru.json": 72592,
	"./CallerIdList/en.json": 10139,
	"./CallerIdList/ru.json": 92383,
	"./Calls/en.json": 5753,
	"./Calls/ru.json": 32011,
	"./CallsCheck/en.json": 35358,
	"./CallsCheck/ru.json": 24975,
	"./CallsCheckToOrders/en.json": 73769,
	"./CallsCheckToOrders/ru.json": 97073,
	"./CallsMonitoringReport/en.json": 62564,
	"./CallsMonitoringReport/ru.json": 16584,
	"./CallsSearchInput/en.json": 27584,
	"./CallsSearchInput/ru.json": 64721,
	"./CallsState/en.json": 76208,
	"./CallsState/ru.json": 95928,
	"./CampaignLeads/en.json": 47843,
	"./CampaignLeads/ru.json": 94732,
	"./CampaignLeadsHeader/en.json": 90223,
	"./CampaignLeadsHeader/ru.json": 51495,
	"./CampaignLeadsTable/en.json": 92577,
	"./CampaignLeadsTable/ru.json": 5281,
	"./CampaignOptions/en.json": 60058,
	"./CampaignOptions/ru.json": 72108,
	"./CdpAggregationSelect/en.json": 74781,
	"./CdpAggregationSelect/ru.json": 57795,
	"./CdpEventAttributeSelect/en.json": 88049,
	"./CdpEventAttributeSelect/ru.json": 64537,
	"./CdpEventSelect/en.json": 82409,
	"./CdpEventSelect/ru.json": 30705,
	"./CdpPersonAttributeSelect/en.json": 23775,
	"./CdpPersonAttributeSelect/ru.json": 70535,
	"./CdpSegmentSelect/en.json": 61189,
	"./CdpSegmentSelect/ru.json": 40895,
	"./ChatBotSetup/en.json": 46816,
	"./ChatBotSetup/ru.json": 93766,
	"./ChatBotSetupGroups/en.json": 74674,
	"./ChatBotSetupGroups/ru.json": 15026,
	"./ChatBotSetups/en.json": 51393,
	"./ChatBotSetups/ru.json": 61366,
	"./ChatMessage/en.json": 5630,
	"./ChatMessage/ru.json": 97447,
	"./ChatQueueForm/en.json": 64980,
	"./ChatQueueForm/ru.json": 524,
	"./ChatQueueOperators/en.json": 65084,
	"./ChatQueueOperators/ru.json": 24526,
	"./ChatTransferNotice/en.json": 22662,
	"./ChatTransferNotice/ru.json": 46803,
	"./CheapGlobal/en.json": 89569,
	"./CheapGlobal/ru.json": 26377,
	"./CheckRobotInOrders/en.json": 54008,
	"./CheckRobotInOrders/ru.json": 60036,
	"./ClientWaTemplateRow/en.json": 17968,
	"./ClientWaTemplateRow/ru.json": 96410,
	"./CodeModal/en.json": 19208,
	"./CodeModal/ru.json": 67833,
	"./CohortDoc/en.json": 48839,
	"./CohortDoc/ru.json": 82575,
	"./CohortForm/en.json": 32994,
	"./CohortForm/ru.json": 90517,
	"./CohortRecalculationCreate/en.json": 66955,
	"./CohortRecalculationCreate/ru.json": 36138,
	"./CohortRecalculationView/en.json": 97482,
	"./CohortRecalculationView/ru.json": 57205,
	"./CohortRecalculationsList/en.json": 1041,
	"./CohortRecalculationsList/ru.json": 59659,
	"./CohortSelector/en.json": 57145,
	"./CohortSelector/ru.json": 81675,
	"./Cohorts/en.json": 20567,
	"./Cohorts/ru.json": 5189,
	"./ComeBackRequestForm/en.json": 92542,
	"./ComeBackRequestForm/ru.json": 20519,
	"./CommonReport/en.json": 73724,
	"./CommonReport/ru.json": 83382,
	"./CommpeakForm/en.json": 38357,
	"./CommpeakForm/ru.json": 16350,
	"./Competence/en.json": 48379,
	"./Competence/ru.json": 6184,
	"./CompetenceCat/en.json": 840,
	"./CompetenceCat/ru.json": 75420,
	"./CompetenceCats/en.json": 73666,
	"./CompetenceCats/ru.json": 92594,
	"./CompetenceGroups/en.json": 94042,
	"./CompetenceGroups/ru.json": 48956,
	"./Competences/en.json": 82741,
	"./Competences/ru.json": 93014,
	"./ComputedFieldModal/en.json": 16978,
	"./ComputedFieldModal/ru.json": 89380,
	"./ComputedFieldsManager/en.json": 75008,
	"./ComputedFieldsManager/ru.json": 63856,
	"./ComputedFieldsMiniList/en.json": 25092,
	"./ComputedFieldsMiniList/ru.json": 51469,
	"./ConditionAudio/en.json": 81324,
	"./ConditionAudio/ru.json": 86886,
	"./ConditionBlock/en.json": 33366,
	"./ConditionBlock/ru.json": 80724,
	"./ConditionGroup/en.json": 34084,
	"./ConditionGroup/ru.json": 58210,
	"./ConditionMessageStatusForm/en.json": 21740,
	"./ConditionMessageStatusForm/ru.json": 95071,
	"./ConditionOrderFieldForm/en.json": 84493,
	"./ConditionOrderFieldForm/ru.json": 85554,
	"./ConditionRepeatForm/en.json": 29435,
	"./ConditionRepeatForm/ru.json": 64437,
	"./ConditionTimeoutForm/en.json": 59345,
	"./ConditionTimeoutForm/ru.json": 91530,
	"./ConfidentialWarningModal/en.json": 66400,
	"./ConfidentialWarningModal/ru.json": 1879,
	"./ConfirmPopupInfo/en.json": 41401,
	"./ConfirmPopupInfo/ru.json": 21482,
	"./ConfirmationModal/en.json": 63588,
	"./ConfirmationModal/ru.json": 33887,
	"./ConsolidatedReport/en.json": 25982,
	"./ConsolidatedReport/ru.json": 1076,
	"./ContrahenHrmParams/en.json": 87769,
	"./ContrahenHrmParams/ru.json": 88102,
	"./ContrahenLoadFinishedNotice/en.json": 23638,
	"./ContrahenLoadFinishedNotice/ru.json": 4287,
	"./ContrahenTaxiCompany/en.json": 81483,
	"./ContrahenTaxiCompany/ru.json": 83795,
	"./Copies/en.json": 49643,
	"./Copies/ru.json": 66616,
	"./Copy/en.json": 67766,
	"./Copy/ru.json": 6,
	"./CopyBpForm/en.json": 61872,
	"./CopyBpForm/ru.json": 26166,
	"./CopyRobotForm/en.json": 3874,
	"./CopyRobotForm/ru.json": 78975,
	"./CopySettingsForm/en.json": 6474,
	"./CopySettingsForm/ru.json": 27570,
	"./CronEditor/en.json": 947,
	"./CronEditor/ru.json": 69757,
	"./CronSelect/en.json": 73321,
	"./CronSelect/ru.json": 91863,
	"./Currencies/en.json": 57947,
	"./Currencies/ru.json": 50576,
	"./Currency/en.json": 26295,
	"./Currency/ru.json": 36511,
	"./CurrentCalls/en.json": 44573,
	"./CurrentCalls/ru.json": 54739,
	"./CustomIntegration/en.json": 87845,
	"./CustomIntegration/ru.json": 77901,
	"./CustomIntegrationEvent/en.json": 8761,
	"./CustomIntegrationEvent/ru.json": 20479,
	"./CustomIntegrationPreview/en.json": 94723,
	"./CustomIntegrationPreview/ru.json": 93281,
	"./CustomIntegrationTabs/en.json": 65065,
	"./CustomIntegrationTabs/ru.json": 73435,
	"./CustomIntegrationTest/en.json": 64038,
	"./CustomIntegrationTest/ru.json": 1608,
	"./DataGrid/en.json": 5110,
	"./DataGrid/ru.json": 58627,
	"./DataGridCallToOrderTemplate/en.json": 70601,
	"./DataGridCallToOrderTemplate/ru.json": 57848,
	"./DataGridFilterCheckList/en.json": 40400,
	"./DataGridFilterCheckList/ru.json": 52161,
	"./DataGridGrouped/en.json": 35261,
	"./DataGridGrouped/ru.json": 80714,
	"./DataGridTelDetailsTemplate/en.json": 67263,
	"./DataGridTelDetailsTemplate/ru.json": 41897,
	"./DateIntervalEditor/en.json": 3951,
	"./DateIntervalEditor/ru.json": 87251,
	"./DatePeriodSelector/en.json": 54394,
	"./DatePeriodSelector/ru.json": 22552,
	"./DatePickerEditor/en.json": 2294,
	"./DatePickerEditor/ru.json": 75892,
	"./DecisionTelecomForm/en.json": 73541,
	"./DecisionTelecomForm/ru.json": 84760,
	"./DecisionTemplate/en.json": 98234,
	"./DecisionTemplate/ru.json": 95881,
	"./DecisionTemplates/en.json": 49569,
	"./DecisionTemplates/ru.json": 70095,
	"./DefaultHeaderDropdownAccnt/en.json": 47884,
	"./DefaultHeaderDropdownAccnt/ru.json": 99020,
	"./DefaultHeaderSipCall/en.json": 90791,
	"./DefaultHeaderSipCall/ru.json": 79599,
	"./DefaultNotifications/en.json": 76939,
	"./DefaultNotifications/ru.json": 18476,
	"./DeliveryDpdReport/en.json": 43483,
	"./DeliveryDpdReport/ru.json": 2282,
	"./DeliveryType/en.json": 24037,
	"./DeliveryType/ru.json": 18479,
	"./DeliveryTypeProjects/en.json": 26559,
	"./DeliveryTypeProjects/ru.json": 97066,
	"./DeliveryTypes/en.json": 66524,
	"./DeliveryTypes/ru.json": 13791,
	"./DetailedReportCallsAndSms/en.json": 37069,
	"./DetailedReportCallsAndSms/ru.json": 19761,
	"./DetailedReportCallsAndSmsNotify/en.json": 40896,
	"./DetailedReportCallsAndSmsNotify/ru.json": 38492,
	"./DeviceToggle/en.json": 59859,
	"./DeviceToggle/ru.json": 15537,
	"./DialCoeff/en.json": 62608,
	"./DialCoeff/ru.json": 14179,
	"./DialogViewModal/en.json": 28277,
	"./DialogViewModal/ru.json": 19471,
	"./DialogsList/en.json": 41365,
	"./DialogsList/ru.json": 22870,
	"./DidGlobalForm/en.json": 29721,
	"./DidGlobalForm/ru.json": 48187,
	"./DmnEditor/en.json": 95210,
	"./DmnEditor/ru.json": 31737,
	"./DmnPreview/en.json": 27365,
	"./DmnPreview/ru.json": 52596,
	"./DmnWelcome/en.json": 86156,
	"./DmnWelcome/ru.json": 22573,
	"./DocumentForm/en.json": 17388,
	"./DocumentForm/ru.json": 94834,
	"./DocumentItem/en.json": 81149,
	"./DocumentItem/ru.json": 92727,
	"./DomainKeys/en.json": 6584,
	"./DomainKeys/ru.json": 24319,
	"./DomainList/en.json": 42399,
	"./DomainList/ru.json": 52170,
	"./DomainSelect/en.json": 69009,
	"./DomainSelect/ru.json": 6431,
	"./DropdownLanguageSelect/en.json": 94101,
	"./DropdownLanguageSelect/ru.json": 65544,
	"./DropdownModeration/en.json": 48916,
	"./DropdownModeration/ru.json": 38907,
	"./DropdownNluGroupSelect/en.json": 86255,
	"./DropdownNluGroupSelect/ru.json": 73481,
	"./DropdownSmsProvider/en.json": 95138,
	"./DropdownSmsProvider/ru.json": 82918,
	"./Dtxt/en.json": 70336,
	"./Dtxt/ru.json": 75444,
	"./DynamicTextBuilder/en.json": 92350,
	"./DynamicTextBuilder/ru.json": 67210,
	"./EditAccostWaTpl/en.json": 22378,
	"./EditAccostWaTpl/ru.json": 80662,
	"./EditAudioAccost/en.json": 9985,
	"./EditAudioAccost/ru.json": 29074,
	"./EditCommonColumnReport/en.json": 55054,
	"./EditCommonColumnReport/ru.json": 62275,
	"./EditInputAccost/en.json": 77334,
	"./EditInputAccost/ru.json": 99734,
	"./EditTextareaAccost/en.json": 40691,
	"./EditTextareaAccost/ru.json": 28237,
	"./EditWaTemplate/en.json": 30173,
	"./EditWaTemplate/ru.json": 97195,
	"./EditingDataGrid/en.json": 8849,
	"./EditingDataGrid/ru.json": 46476,
	"./EdnaForm/en.json": 67171,
	"./EdnaForm/ru.json": 23397,
	"./EimsForm/en.json": 27096,
	"./EimsForm/ru.json": 60841,
	"./EmailProvider/en.json": 28421,
	"./EmailProvider/ru.json": 68967,
	"./EmailProviders/en.json": 79257,
	"./EmailProviders/ru.json": 8223,
	"./EmailTemplate/en.json": 44525,
	"./EmailTemplate/ru.json": 72528,
	"./EmailTemplates/en.json": 76884,
	"./EmailTemplates/ru.json": 7240,
	"./EmojiBar/en.json": 42544,
	"./EmojiBar/ru.json": 62139,
	"./Entities/en.json": 27646,
	"./Entities/ru.json": 88621,
	"./Entity/en.json": 19423,
	"./Entity/ru.json": 87969,
	"./ExampleOrders/en.json": 40483,
	"./ExampleOrders/ru.json": 94414,
	"./ExolveForm/en.json": 85230,
	"./ExolveForm/ru.json": 13630,
	"./ExpendedFilter/en.json": 7962,
	"./ExpendedFilter/ru.json": 21799,
	"./ExpiredUserForms/en.json": 905,
	"./ExpiredUserForms/ru.json": 22071,
	"./FastFilter/en.json": 26588,
	"./FastFilter/ru.json": 46320,
	"./FileUploadButton/en.json": 60169,
	"./FileUploadButton/ru.json": 82188,
	"./FillOrderForm/en.json": 23758,
	"./FillOrderForm/ru.json": 47459,
	"./FilterBuilder/en.json": 35559,
	"./FilterBuilder/ru.json": 81294,
	"./FilterCheckList/en.json": 6124,
	"./FilterCheckList/ru.json": 47597,
	"./Fine/en.json": 32825,
	"./Fine/ru.json": 54606,
	"./FineCat/en.json": 34918,
	"./FineCat/ru.json": 70206,
	"./FineCats/en.json": 1094,
	"./FineCats/ru.json": 14848,
	"./FineHistory/en.json": 357,
	"./FineHistory/ru.json": 56455,
	"./Fines/en.json": 94784,
	"./Fines/ru.json": 27209,
	"./FinesReport/en.json": 84629,
	"./FinesReport/ru.json": 96504,
	"./FormModal/en.json": 4092,
	"./FormModal/ru.json": 58707,
	"./FrodReport/en.json": 49469,
	"./FrodReport/ru.json": 10297,
	"./FtpIntegrationTest/en.json": 1844,
	"./FtpIntegrationTest/ru.json": 29890,
	"./FtpSetup/en.json": 60210,
	"./FtpSetup/ru.json": 70861,
	"./Geo/en.json": 89534,
	"./Geo/ru.json": 99574,
	"./Geos/en.json": 97429,
	"./Geos/ru.json": 47550,
	"./GlobahubForm/en.json": 32845,
	"./GlobahubForm/ru.json": 40636,
	"./GradeOption/en.json": 46563,
	"./GradeOption/ru.json": 45942,
	"./GradeOptions/en.json": 35606,
	"./GradeOptions/ru.json": 87754,
	"./HHIntegration/en.json": 3674,
	"./HHIntegration/ru.json": 67194,
	"./HHResumes/en.json": 81652,
	"./HHResumes/ru.json": 39381,
	"./History/en.json": 8342,
	"./History/ru.json": 55394,
	"./HistoryItem/en.json": 40476,
	"./HistoryItem/ru.json": 78888,
	"./HistoryLine/en.json": 749,
	"./HistoryLine/ru.json": 58714,
	"./HomeCreditForm/en.json": 71150,
	"./HomeCreditForm/ru.json": 27423,
	"./HpBase/en.json": 67888,
	"./HpBase/ru.json": 66312,
	"./HpBaseForm/en.json": 45609,
	"./HpBaseForm/ru.json": 63447,
	"./HrChiefs/en.json": 7285,
	"./HrChiefs/ru.json": 95798,
	"./HrCompanies/en.json": 87486,
	"./HrCompanies/ru.json": 35988,
	"./HrDivisions/en.json": 24535,
	"./HrDivisions/ru.json": 59723,
	"./HrList/en.json": 7220,
	"./HrList/ru.json": 30907,
	"./HrRates/en.json": 33134,
	"./HrRates/ru.json": 98971,
	"./HrSkills/en.json": 88493,
	"./HrSkills/ru.json": 14598,
	"./HrVacancies/en.json": 5781,
	"./HrVacancies/ru.json": 46648,
	"./Hss/en.json": 18416,
	"./Hss/ru.json": 44305,
	"./HtmlCodeEditor/en.json": 69814,
	"./HtmlCodeEditor/ru.json": 17160,
	"./HtmlEditorSplitView/en.json": 33241,
	"./HtmlEditorSplitView/ru.json": 95404,
	"./HtmlPreview/en.json": 97254,
	"./HtmlPreview/ru.json": 10626,
	"./HttpRequestForm/en.json": 72304,
	"./HttpRequestForm/ru.json": 42441,
	"./IQsentForm/en.json": 18484,
	"./IQsentForm/ru.json": 92865,
	"./ImageForm/en.json": 85379,
	"./ImageForm/ru.json": 39621,
	"./ImageItem/en.json": 50304,
	"./ImageItem/ru.json": 51531,
	"./InboxFields/en.json": 8843,
	"./InboxFields/ru.json": 56110,
	"./InboxPreview/en.json": 51410,
	"./InboxPreview/ru.json": 29274,
	"./IncomingCallAlert/en.json": 14659,
	"./IncomingCallAlert/ru.json": 18204,
	"./Industries/en.json": 68706,
	"./Industries/ru.json": 24236,
	"./InfobipForm/en.json": 4574,
	"./InfobipForm/ru.json": 62429,
	"./InlineFormVariable/en.json": 68516,
	"./InlineFormVariable/ru.json": 32879,
	"./Integrations/en.json": 64845,
	"./Integrations/ru.json": 21473,
	"./IntentFileForm/en.json": 20779,
	"./IntentFileForm/ru.json": 56194,
	"./IntentForm/en.json": 35246,
	"./IntentForm/ru.json": 31494,
	"./IntentsHistory/en.json": 33971,
	"./IntentsHistory/ru.json": 1123,
	"./InterconnectForm/en.json": 48584,
	"./InterconnectForm/ru.json": 95634,
	"./Interpretation/en.json": 56090,
	"./Interpretation/ru.json": 1968,
	"./Interpretations/en.json": 51667,
	"./Interpretations/ru.json": 10867,
	"./IntisteleForm/en.json": 66139,
	"./IntisteleForm/ru.json": 96316,
	"./IqSmsForm/en.json": 27478,
	"./IqSmsForm/ru.json": 13652,
	"./ItemBotHistory/en.json": 20490,
	"./ItemBotHistory/ru.json": 40179,
	"./ItemIntentHistory/en.json": 80576,
	"./ItemIntentHistory/ru.json": 88136,
	"./JsCodeEditor/en.json": 4335,
	"./JsCodeEditor/ru.json": 85866,
	"./JumpConditions/en.json": 77255,
	"./JumpConditions/ru.json": 63174,
	"./JumpConditionsModal/en.json": 7498,
	"./JumpConditionsModal/ru.json": 85474,
	"./KarixForm/en.json": 43471,
	"./KarixForm/ru.json": 31253,
	"./KassaComPaymentNotice/en.json": 8984,
	"./KassaComPaymentNotice/ru.json": 5726,
	"./LaafficForm/en.json": 28849,
	"./LaafficForm/ru.json": 50627,
	"./Lags/en.json": 41214,
	"./Lags/ru.json": 66778,
	"./LaravelRule/en.json": 89542,
	"./LaravelRule/ru.json": 81285,
	"./LexicoForm/en.json": 13665,
	"./LexicoForm/ru.json": 89786,
	"./LexicoOtpForm/en.json": 33430,
	"./LexicoOtpForm/ru.json": 67698,
	"./LinkInfo/en.json": 57783,
	"./LinkInfo/ru.json": 89067,
	"./LinkListTable/en.json": 82591,
	"./LinkListTable/ru.json": 39325,
	"./LinkTelegramAccount/en.json": 76553,
	"./LinkTelegramAccount/ru.json": 35746,
	"./LinkToolbar/en.json": 82562,
	"./LinkToolbar/ru.json": 93854,
	"./LinksManagementModal/en.json": 20454,
	"./LinksManagementModal/ru.json": 59310,
	"./LlmConnectorForm/en.json": 43410,
	"./LlmConnectorForm/ru.json": 44122,
	"./LlmMonitoringPage/en.json": 41609,
	"./LlmMonitoringPage/ru.json": 75207,
	"./LlmPromptForm/en.json": 36382,
	"./LlmPromptForm/ru.json": 6212,
	"./LlmPromptList/en.json": 86567,
	"./LlmPromptList/ru.json": 60542,
	"./LlmPromptsPage/en.json": 68386,
	"./LlmPromptsPage/ru.json": 82139,
	"./LlmRequestAction/en.json": 81193,
	"./LlmRequestAction/ru.json": 73364,
	"./LlmRequestDetailsModal/en.json": 58850,
	"./LlmRequestDetailsModal/ru.json": 30103,
	"./LlmRequestTest/en.json": 68698,
	"./LlmRequestTest/ru.json": 8294,
	"./LlmSettings/en.json": 30287,
	"./LlmSettings/ru.json": 48679,
	"./LogActivities/en.json": 86373,
	"./LogActivities/ru.json": 38556,
	"./LogisticCallsReport/en.json": 97092,
	"./LogisticCallsReport/ru.json": 46866,
	"./LogisticReport/en.json": 86398,
	"./LogisticReport/ru.json": 50095,
	"./MChat/en.json": 98322,
	"./MChat/ru.json": 15378,
	"./MChatFilters/en.json": 23480,
	"./MChatFilters/ru.json": 23332,
	"./MChatListTemplates/en.json": 1387,
	"./MChatListTemplates/ru.json": 22648,
	"./MChatRoomWindow/en.json": 30707,
	"./MChatRoomWindow/ru.json": 41734,
	"./MChatRooms/en.json": 23093,
	"./MChatRooms/ru.json": 79329,
	"./MChatSegmentSidebar/en.json": 63669,
	"./MChatSegmentSidebar/ru.json": 99386,
	"./MChatSidebar/en.json": 82537,
	"./MChatSidebar/ru.json": 16338,
	"./MChatUpdate/en.json": 46398,
	"./MChatUpdate/ru.json": 64732,
	"./MainSmsForm/en.json": 73970,
	"./MainSmsForm/ru.json": 14108,
	"./MamontyForm/en.json": 21299,
	"./MamontyForm/ru.json": 88313,
	"./MarkdownRenderer/en.json": 31277,
	"./MarkdownRenderer/ru.json": 71759,
	"./MedProjectReport/en.json": 42398,
	"./MedProjectReport/ru.json": 65033,
	"./MessagewhizForm/en.json": 73817,
	"./MessagewhizForm/ru.json": 40220,
	"./MessaggioForm/en.json": 95147,
	"./MessaggioForm/ru.json": 72197,
	"./MessengerAccounts/en.json": 8215,
	"./MessengerAccounts/ru.json": 73240,
	"./MessengerSetup/en.json": 3823,
	"./MessengerSetup/ru.json": 43568,
	"./MiatelForm/en.json": 78083,
	"./MiatelForm/ru.json": 94287,
	"./MiniAnalytics/en.json": 39983,
	"./MiniAnalytics/ru.json": 3801,
	"./MixinResourceEntity/en.json": 45674,
	"./MixinResourceEntity/ru.json": 7252,
	"./MlDashboard/en.json": 24486,
	"./MlDashboard/ru.json": 68552,
	"./MobivateForm/en.json": 35906,
	"./MobivateForm/ru.json": 42285,
	"./MobizonForm/en.json": 65827,
	"./MobizonForm/ru.json": 6077,
	"./ModelInput/en.json": 47579,
	"./ModelInput/ru.json": 78258,
	"./MrmSmsForm/en.json": 9027,
	"./MrmSmsForm/ru.json": 56379,
	"./MultiLevelFilter/en.json": 40729,
	"./MultiLevelFilter/ru.json": 8634,
	"./MultiLevelFilterNew/en.json": 30260,
	"./MultiLevelFilterNew/ru.json": 44554,
	"./MultipleInput/en.json": 83455,
	"./MultipleInput/ru.json": 9966,
	"./MultiselectStatuses/en.json": 19594,
	"./MultiselectStatuses/ru.json": 23348,
	"./MyCampaignSegmentsMultiselect/en.json": 84218,
	"./MyCampaignSegmentsMultiselect/ru.json": 57775,
	"./MyCampaignsMultiselect/en.json": 29694,
	"./MyCampaignsMultiselect/ru.json": 3262,
	"./MyTargetNotice/en.json": 46703,
	"./MyTargetNotice/ru.json": 77466,
	"./MyTargetSetNotice/en.json": 81235,
	"./MyTargetSetNotice/ru.json": 43905,
	"./Nav/en.json": 92189,
	"./Nav/ru.json": 67652,
	"./NewOptOrder/en.json": 17170,
	"./NewOptOrder/ru.json": 18490,
	"./NewOptOrderSales/en.json": 77892,
	"./NewOptOrderSales/ru.json": 76610,
	"./NewOptOrderServices/en.json": 36465,
	"./NewOptOrderServices/ru.json": 62012,
	"./NewOrder/en.json": 74813,
	"./NewOrder/ru.json": 34353,
	"./NluGroupForm/en.json": 11428,
	"./NluGroupForm/ru.json": 42839,
	"./NluGroupList/en.json": 21666,
	"./NluGroupList/ru.json": 11205,
	"./NluIntentSelector/en.json": 15820,
	"./NluIntentSelector/ru.json": 71652,
	"./NluItem/en.json": 80276,
	"./NluItem/ru.json": 64278,
	"./NluList/en.json": 75617,
	"./NluList/ru.json": 35154,
	"./NluServerForm/en.json": 26607,
	"./NluServerForm/ru.json": 35866,
	"./NluServerList/en.json": 88637,
	"./NluServerList/ru.json": 229,
	"./NluTest/en.json": 37907,
	"./NluTest/ru.json": 79838,
	"./NoFilterDataGrid/en.json": 18353,
	"./NoFilterDataGrid/ru.json": 19874,
	"./Notification/en.json": 79875,
	"./Notification/ru.json": 67034,
	"./NotificationActions/en.json": 38972,
	"./NotificationActions/ru.json": 26623,
	"./NotificationFormFields/en.json": 23888,
	"./NotificationFormFields/ru.json": 99208,
	"./NotificationPreview/en.json": 69361,
	"./NotificationPreview/ru.json": 99551,
	"./NotificationTemplateForm/en.json": 69950,
	"./NotificationTemplateForm/ru.json": 9076,
	"./NotificationTemplates/en.json": 83973,
	"./NotificationTemplates/ru.json": 66217,
	"./Notifications/en.json": 6068,
	"./Notifications/ru.json": 50806,
	"./NotificationsOnSiteStatistics/en.json": 52405,
	"./NotificationsOnSiteStatistics/ru.json": 37833,
	"./NotificoreForm/en.json": 2122,
	"./NotificoreForm/ru.json": 41258,
	"./OakTelecomForm/en.json": 37754,
	"./OakTelecomForm/ru.json": 19329,
	"./OfferAccept/en.json": 61071,
	"./OfferAccept/ru.json": 52031,
	"./OnAutoRespForm/en.json": 49085,
	"./OnAutoRespForm/ru.json": 36963,
	"./OnSiteFields/en.json": 88946,
	"./OnSiteFields/ru.json": 36706,
	"./OnSiteNotifications/en.json": 53188,
	"./OnSiteNotifications/ru.json": 98212,
	"./OperPanelNotifyPopup/en.json": 91854,
	"./OperPanelNotifyPopup/ru.json": 21715,
	"./OperStates/en.json": 34443,
	"./OperStates/ru.json": 72703,
	"./OperatorPanel/en.json": 82445,
	"./OperatorPanel/ru.json": 68941,
	"./OperatorScriptTrTable/en.json": 9550,
	"./OperatorScriptTrTable/ru.json": 94612,
	"./OperatorsChart/en.json": 15403,
	"./OperatorsChart/ru.json": 55150,
	"./OptOrder/en.json": 82623,
	"./OptOrder/ru.json": 51473,
	"./OptOrderComment/en.json": 8878,
	"./OptOrderComment/ru.json": 20403,
	"./OptOrderForm/en.json": 65965,
	"./OptOrderForm/ru.json": 75430,
	"./OptOrderHeader/en.json": 79795,
	"./OptOrderHeader/ru.json": 18193,
	"./OptOrderHistory/en.json": 68488,
	"./OptOrderHistory/ru.json": 40367,
	"./OptOrderSales/en.json": 44055,
	"./OptOrderSales/ru.json": 17833,
	"./OptOrderServices/en.json": 32096,
	"./OptOrderServices/ru.json": 93582,
	"./OptOrderStatus/en.json": 917,
	"./OptOrderStatus/ru.json": 2422,
	"./OptOrders/en.json": 64469,
	"./OptOrders/ru.json": 83619,
	"./OptTrafficSource/en.json": 91666,
	"./OptTrafficSource/ru.json": 18817,
	"./OptTrafficSources/en.json": 45360,
	"./OptTrafficSources/ru.json": 68294,
	"./Order/en.json": 15658,
	"./Order/ru.json": 19158,
	"./OrderCall/en.json": 62570,
	"./OrderCall/ru.json": 63248,
	"./OrderCohortHistory/en.json": 29934,
	"./OrderCohortHistory/ru.json": 70357,
	"./OrderComment/en.json": 28164,
	"./OrderComment/ru.json": 8569,
	"./OrderDeferredCommunications/en.json": 75423,
	"./OrderDeferredCommunications/ru.json": 63181,
	"./OrderDialTime/en.json": 59641,
	"./OrderDialTime/ru.json": 33624,
	"./OrderForm/en.json": 96766,
	"./OrderForm/ru.json": 44200,
	"./OrderFrodNotice/en.json": 22759,
	"./OrderFrodNotice/ru.json": 10033,
	"./OrderHeader/en.json": 93151,
	"./OrderHeader/ru.json": 77448,
	"./OrderHistory/en.json": 63600,
	"./OrderHistory/ru.json": 21728,
	"./OrderHrmContrahen/en.json": 620,
	"./OrderHrmContrahen/ru.json": 1036,
	"./OrderHrmContrahenLeftBlock/en.json": 87025,
	"./OrderHrmContrahenLeftBlock/ru.json": 160,
	"./OrderHrmParam/en.json": 62101,
	"./OrderHrmParam/ru.json": 37085,
	"./OrderLoad/en.json": 48908,
	"./OrderLoad/ru.json": 33839,
	"./OrderRobotFile/en.json": 52759,
	"./OrderRobotFile/ru.json": 46578,
	"./OrderRobotInfo/en.json": 60699,
	"./OrderRobotInfo/ru.json": 7682,
	"./OrderSales/en.json": 1696,
	"./OrderSales/ru.json": 68738,
	"./OrderSearchInput/en.json": 94394,
	"./OrderSearchInput/ru.json": 60034,
	"./OrderSender/en.json": 80610,
	"./OrderSender/ru.json": 82437,
	"./OrderSenders/en.json": 456,
	"./OrderSenders/ru.json": 13554,
	"./OrderStatus/en.json": 44774,
	"./OrderStatus/ru.json": 12867,
	"./OrderTaxiContrahenLeftBlock/en.json": 10672,
	"./OrderTaxiContrahenLeftBlock/ru.json": 89460,
	"./OrderTypes/en.json": 20112,
	"./OrderTypes/ru.json": 69049,
	"./OrderValidator/en.json": 65253,
	"./OrderValidator/ru.json": 52833,
	"./OrderValidatorRule/en.json": 22078,
	"./OrderValidatorRule/ru.json": 57275,
	"./Orders/en.json": 12437,
	"./Orders/ru.json": 71461,
	"./OrdersColumns/en.json": 1483,
	"./OrdersColumns/ru.json": 23146,
	"./OrganizationAtsGroups/en.json": 38016,
	"./OrganizationAtsGroups/ru.json": 71543,
	"./OrganizationAtsQueues/en.json": 65514,
	"./OrganizationAtsQueues/ru.json": 55947,
	"./OrganizationBindings/en.json": 99100,
	"./OrganizationBindings/ru.json": 27199,
	"./OrganizationCard/en.json": 75499,
	"./OrganizationCard/ru.json": 44611,
	"./OrganizationForm/en.json": 52312,
	"./OrganizationForm/ru.json": 41059,
	"./OrganizationInterfaceForm/en.json": 21174,
	"./OrganizationInterfaceForm/ru.json": 53849,
	"./OrganizationUsersList/en.json": 31999,
	"./OrganizationUsersList/ru.json": 27748,
	"./OrganizationUsersSearchList/en.json": 56218,
	"./OrganizationUsersSearchList/ru.json": 78026,
	"./Organizations/en.json": 9648,
	"./Organizations/ru.json": 1064,
	"./Otsledi/en.json": 96877,
	"./Otsledi/ru.json": 71884,
	"./OutRouteForm/en.json": 38017,
	"./OutRouteForm/ru.json": 45728,
	"./OutRoutes/en.json": 8857,
	"./OutRoutes/ru.json": 38316,
	"./Owner/en.json": 84699,
	"./Owner/ru.json": 19639,
	"./Owners/en.json": 32810,
	"./Owners/ru.json": 43877,
	"./POneSmsForm/en.json": 73644,
	"./POneSmsForm/ru.json": 38405,
	"./PaasooForm/en.json": 53400,
	"./PaasooForm/ru.json": 87093,
	"./Packed/en.json": 20817,
	"./Packed/ru.json": 63357,
	"./PackedBarcode/en.json": 22304,
	"./PackedBarcode/ru.json": 60998,
	"./PackedReport/en.json": 85030,
	"./PackedReport/ru.json": 18623,
	"./PackedSpeedStandard/en.json": 77327,
	"./PackedSpeedStandard/ru.json": 40692,
	"./PackedSpeedStandards/en.json": 75621,
	"./PackedSpeedStandards/ru.json": 63402,
	"./PaymentType/en.json": 65653,
	"./PaymentType/ru.json": 57220,
	"./PaymentTypes/en.json": 60631,
	"./PaymentTypes/ru.json": 72594,
	"./PhoneInput/en.json": 81328,
	"./PhoneInput/ru.json": 41508,
	"./PhraseForm/en.json": 36595,
	"./PhraseForm/ru.json": 4565,
	"./PhraseList/en.json": 87048,
	"./PhraseList/ru.json": 26341,
	"./PivotGrid/en.json": 27811,
	"./PivotGrid/ru.json": 89439,
	"./PointsWithGrade/en.json": 28364,
	"./PointsWithGrade/ru.json": 88909,
	"./PointsWithGrades/en.json": 12764,
	"./PointsWithGrades/ru.json": 33630,
	"./Product/en.json": 34165,
	"./Product/ru.json": 16033,
	"./ProductCategories/en.json": 42550,
	"./ProductCategories/ru.json": 6767,
	"./ProductCategory/en.json": 65503,
	"./ProductCategory/ru.json": 82689,
	"./Products/en.json": 85959,
	"./Products/ru.json": 80856,
	"./ProfileAchievements/en.json": 98175,
	"./ProfileAchievements/ru.json": 15738,
	"./ProfileAchievementsTable/en.json": 31159,
	"./ProfileAchievementsTable/ru.json": 46706,
	"./ProfileAchievementsTableSimple/en.json": 29857,
	"./ProfileAchievementsTableSimple/ru.json": 58141,
	"./ProfileApiKeyEdit/en.json": 53361,
	"./ProfileApiKeyEdit/ru.json": 56008,
	"./ProfileCalc/en.json": 26565,
	"./ProfileCalc/ru.json": 37378,
	"./ProfileFines/en.json": 94785,
	"./ProfileFines/ru.json": 91680,
	"./ProfileInfo/en.json": 17489,
	"./ProfileInfo/ru.json": 48671,
	"./ProfileInterface/en.json": 13979,
	"./ProfileInterface/ru.json": 2215,
	"./ProfileLogs/en.json": 45451,
	"./ProfileLogs/ru.json": 50839,
	"./ProfileMyTargets/en.json": 22414,
	"./ProfileMyTargets/ru.json": 87543,
	"./ProfileOrderPhones/en.json": 49664,
	"./ProfileOrderPhones/ru.json": 22803,
	"./ProfilePage/en.json": 58999,
	"./ProfilePage/ru.json": 84390,
	"./ProfilePassword/en.json": 17702,
	"./ProfilePassword/ru.json": 66453,
	"./ProfilePasswordForm/en.json": 29729,
	"./ProfilePasswordForm/ru.json": 89196,
	"./ProfileScriptList/en.json": 39151,
	"./ProfileScriptList/ru.json": 75025,
	"./ProfileSips/en.json": 70591,
	"./ProfileSips/ru.json": 299,
	"./ProgressMonitor/en.json": 62314,
	"./ProgressMonitor/ru.json": 80573,
	"./Project/en.json": 89946,
	"./Project/ru.json": 77661,
	"./ProjectCategories/en.json": 52162,
	"./ProjectCategories/ru.json": 56172,
	"./ProjectCategory/en.json": 6377,
	"./ProjectCategory/ru.json": 75375,
	"./ProjectGoalScript/en.json": 85763,
	"./ProjectGoalScript/ru.json": 90702,
	"./ProjectPagePhones/en.json": 43906,
	"./ProjectPagePhones/ru.json": 1721,
	"./Projects/en.json": 28703,
	"./Projects/ru.json": 81160,
	"./PromoCodeTrTable/en.json": 74299,
	"./PromoCodeTrTable/ru.json": 53503,
	"./PromoCodesForm/en.json": 4640,
	"./PromoCodesForm/ru.json": 70942,
	"./ProviderForm/en.json": 85643,
	"./ProviderForm/ru.json": 99519,
	"./Providers/en.json": 3779,
	"./Providers/ru.json": 16256,
	"./PushSenderIntegration/en.json": 25951,
	"./PushSenderIntegration/ru.json": 59970,
	"./PushTemplateForm/en.json": 90202,
	"./PushTemplateForm/ru.json": 75693,
	"./PushTemplatePreview/en.json": 52739,
	"./PushTemplatePreview/ru.json": 48471,
	"./PushTemplateSelector/en.json": 61022,
	"./PushTemplateSelector/ru.json": 97306,
	"./PushTemplatesList/en.json": 86738,
	"./PushTemplatesList/ru.json": 60401,
	"./QazarteleForm/en.json": 16353,
	"./QazarteleForm/ru.json": 19990,
	"./QuestionGroups/en.json": 45070,
	"./QuestionGroups/ru.json": 50580,
	"./QueueStepInput/en.json": 31438,
	"./QueueStepInput/ru.json": 54796,
	"./QueueStepsTable/en.json": 63840,
	"./QueueStepsTable/ru.json": 81615,
	"./QueueWrapper/en.json": 13497,
	"./QueueWrapper/ru.json": 69599,
	"./RBDashboards/en.json": 57824,
	"./RBDashboards/ru.json": 83677,
	"./RBReport/en.json": 53433,
	"./RBReport/ru.json": 61476,
	"./RBReportConfiguration/en.json": 55368,
	"./RBReportConfiguration/ru.json": 81170,
	"./RBReportFilterDateRange/en.json": 27383,
	"./RBReportFilterDateRange/ru.json": 35203,
	"./RBReportFilterSearchableMultiselect/en.json": 2833,
	"./RBReportFilterSearchableMultiselect/ru.json": 19373,
	"./RBReportList/en.json": 9241,
	"./RBReportList/ru.json": 41942,
	"./RBReports/en.json": 50301,
	"./RBReports/ru.json": 83220,
	"./RBSourceColumns/en.json": 28116,
	"./RBSourceColumns/ru.json": 10562,
	"./RBSources/en.json": 90612,
	"./RBSources/ru.json": 64266,
	"./RBTemplateColumnControl/en.json": 48777,
	"./RBTemplateColumnControl/ru.json": 96824,
	"./RBTemplateCreateOrEdit/en.json": 7614,
	"./RBTemplateCreateOrEdit/ru.json": 748,
	"./RBTemplateFilter/en.json": 11695,
	"./RBTemplateFilter/ru.json": 54982,
	"./RBTemplateFilters/en.json": 58506,
	"./RBTemplateFilters/ru.json": 86799,
	"./RBTemplateFunctionalColumn/en.json": 16118,
	"./RBTemplateFunctionalColumn/ru.json": 26839,
	"./RBTemplateFunctionalColumns/en.json": 28098,
	"./RBTemplateFunctionalColumns/ru.json": 20793,
	"./RBTemplateGroup/en.json": 60911,
	"./RBTemplateGroup/ru.json": 62939,
	"./RBTemplateGroups/en.json": 91028,
	"./RBTemplateGroups/ru.json": 89019,
	"./RBTemplateVariable/en.json": 50518,
	"./RBTemplateVariable/ru.json": 90696,
	"./RBTemplateVariables/en.json": 85117,
	"./RBTemplateVariables/ru.json": 62054,
	"./RBTemplates/en.json": 50370,
	"./RBTemplates/ru.json": 89903,
	"./ReasonFine/en.json": 42657,
	"./ReasonFine/ru.json": 1940,
	"./ReasonFines/en.json": 40643,
	"./ReasonFines/ru.json": 81305,
	"./RechargeBalance/en.json": 13051,
	"./RechargeBalance/ru.json": 10589,
	"./RedsmsForm/en.json": 53882,
	"./RedsmsForm/ru.json": 14716,
	"./Refunds/en.json": 48978,
	"./Refunds/ru.json": 43086,
	"./ReportBpm/en.json": 54106,
	"./ReportBpm/ru.json": 52208,
	"./ReportByCalls/en.json": 19486,
	"./ReportByCalls/ru.json": 59885,
	"./ReportBySms/en.json": 6689,
	"./ReportBySms/ru.json": 10790,
	"./ReportOfManualAndAutomaticRinging/en.json": 15859,
	"./ReportOfManualAndAutomaticRinging/ru.json": 85435,
	"./ReportOnBases/en.json": 61291,
	"./ReportOnBases/ru.json": 58008,
	"./ReportSettingManager/en.json": 92213,
	"./ReportSettingManager/ru.json": 50449,
	"./RequestConditions/en.json": 24230,
	"./RequestConditions/ru.json": 85082,
	"./RequestSetup/en.json": 26381,
	"./RequestSetup/ru.json": 99489,
	"./ResultsViewer/en.json": 75523,
	"./ResultsViewer/ru.json": 66321,
	"./RobotBlocks/en.json": 6942,
	"./RobotBlocks/ru.json": 86323,
	"./RobotCallPeriodReport/en.json": 31077,
	"./RobotCallPeriodReport/ru.json": 91617,
	"./RobotHistory/en.json": 72799,
	"./RobotHistory/ru.json": 15693,
	"./RobotIntentSynonyms/en.json": 86843,
	"./RobotIntentSynonyms/ru.json": 66233,
	"./RobotList/en.json": 8841,
	"./RobotList/ru.json": 57308,
	"./RobotOptions/en.json": 5020,
	"./RobotOptions/ru.json": 67458,
	"./RobotOrdersReport/en.json": 62349,
	"./RobotOrdersReport/ru.json": 80252,
	"./RobotPage/en.json": 12801,
	"./RobotPage/ru.json": 87814,
	"./RobotProject/en.json": 61201,
	"./RobotProject/ru.json": 62839,
	"./RobotProjectDialog/en.json": 19977,
	"./RobotProjectDialog/ru.json": 71149,
	"./RobotProjectDialogList/en.json": 40621,
	"./RobotProjectDialogList/ru.json": 9885,
	"./RobotProjectDialogTable/en.json": 33730,
	"./RobotProjectDialogTable/ru.json": 469,
	"./RobotScenarios/en.json": 54951,
	"./RobotScenarios/ru.json": 91227,
	"./RobotSteps/en.json": 90091,
	"./RobotSteps/ru.json": 61126,
	"./RobotTools/en.json": 14250,
	"./RobotTools/ru.json": 72575,
	"./Role/en.json": 26426,
	"./Role/ru.json": 9227,
	"./RoleGroup/en.json": 37762,
	"./RoleGroup/ru.json": 5352,
	"./RoleGroups/en.json": 71984,
	"./RoleGroups/ru.json": 85606,
	"./RoleGroupsCard/en.json": 41278,
	"./RoleGroupsCard/ru.json": 7696,
	"./RoleOrganizationProjectsForm/en.json": 42154,
	"./RoleOrganizationProjectsForm/ru.json": 90174,
	"./Roles/en.json": 31734,
	"./Roles/ru.json": 50650,
	"./RowStartTemplate/en.json": 49576,
	"./RowStartTemplate/ru.json": 34335,
	"./RupeeRedeeForm/en.json": 51790,
	"./RupeeRedeeForm/ru.json": 27054,
	"./SalesAnalyticsExtendReport/en.json": 97252,
	"./SalesAnalyticsExtendReport/ru.json": 6911,
	"./SalesReport/en.json": 71602,
	"./SalesReport/ru.json": 664,
	"./SalesSectionReport/en.json": 29895,
	"./SalesSectionReport/ru.json": 14593,
	"./SaveFilter/en.json": 78461,
	"./SaveFilter/ru.json": 541,
	"./SchedulableAttach/en.json": 46967,
	"./SchedulableAttach/ru.json": 95851,
	"./SchedulableItem/en.json": 85410,
	"./SchedulableItem/ru.json": 32164,
	"./SchedulablesManager/en.json": 89265,
	"./SchedulablesManager/ru.json": 77987,
	"./ScheduleEditor/en.json": 71779,
	"./ScheduleEditor/ru.json": 55875,
	"./ScheduleList/en.json": 71233,
	"./ScheduleList/ru.json": 80280,
	"./ScheduleListView/en.json": 35156,
	"./ScheduleListView/ru.json": 29884,
	"./SchedulerView/en.json": 53902,
	"./SchedulerView/ru.json": 43229,
	"./SchedulerWelcome/en.json": 63431,
	"./SchedulerWelcome/ru.json": 19433,
	"./ScreenJumps/en.json": 95214,
	"./ScreenJumps/ru.json": 36814,
	"./ScreenStatuses/en.json": 31824,
	"./ScreenStatuses/ru.json": 42225,
	"./ScreenTimeoutCondition/en.json": 6084,
	"./ScreenTimeoutCondition/ru.json": 14028,
	"./ScriptsList/en.json": 76072,
	"./ScriptsList/ru.json": 21777,
	"./SearchPanel/en.json": 99188,
	"./SearchPanel/ru.json": 64227,
	"./SecretModal/en.json": 96935,
	"./SecretModal/ru.json": 440,
	"./SecretsManager/en.json": 73431,
	"./SecretsManager/ru.json": 40710,
	"./SecretsMiniList/en.json": 44550,
	"./SecretsMiniList/ru.json": 63652,
	"./SelectRecognition/en.json": 39768,
	"./SelectRecognition/ru.json": 57083,
	"./SelectStartType/en.json": 2110,
	"./SelectStartType/ru.json": 83741,
	"./SempicoForm/en.json": 89230,
	"./SempicoForm/ru.json": 96268,
	"./SendNinetyNineForm/en.json": 14951,
	"./SendNinetyNineForm/ru.json": 13538,
	"./SendblueIMessageForm/en.json": 12529,
	"./SendblueIMessageForm/ru.json": 90734,
	"./SendboxForm/en.json": 13456,
	"./SendboxForm/ru.json": 24071,
	"./SendingSmsForm/en.json": 60331,
	"./SendingSmsForm/ru.json": 2311,
	"./SendsayForm/en.json": 30611,
	"./SendsayForm/ru.json": 14061,
	"./ServerTemplateStatus/en.json": 57922,
	"./ServerTemplateStatus/ru.json": 84926,
	"./ShortenLinkSettings/en.json": 84283,
	"./ShortenLinkSettings/ru.json": 20001,
	"./SigmaSmsForm/en.json": 6831,
	"./SigmaSmsForm/ru.json": 1760,
	"./SimpleUserForm/en.json": 93672,
	"./SimpleUserForm/ru.json": 36687,
	"./SipForm/en.json": 34049,
	"./SipForm/ru.json": 27295,
	"./SipNumberForm/en.json": 23450,
	"./SipNumberForm/ru.json": 64029,
	"./SkillForm/en.json": 90026,
	"./SkillForm/ru.json": 49044,
	"./SkillViewModal/en.json": 14215,
	"./SkillViewModal/ru.json": 10205,
	"./SkillsListPage/en.json": 63577,
	"./SkillsListPage/ru.json": 5360,
	"./SkySmsForm/en.json": 500,
	"./SkySmsForm/ru.json": 39963,
	"./SmsAlaForm/en.json": 19636,
	"./SmsAlaForm/ru.json": 57288,
	"./SmsBeaconLogReportNotice/en.json": 95899,
	"./SmsBeaconLogReportNotice/ru.json": 59866,
	"./SmsBlissForm/en.json": 765,
	"./SmsBlissForm/ru.json": 57141,
	"./SmsBoomForm/en.json": 55383,
	"./SmsBoomForm/ru.json": 97975,
	"./SmsByPhone/en.json": 58450,
	"./SmsByPhone/ru.json": 38256,
	"./SmsCheck/en.json": 55216,
	"./SmsCheck/ru.json": 14548,
	"./SmsCheckToService/en.json": 59118,
	"./SmsCheckToService/ru.json": 72701,
	"./SmsClubForm/en.json": 13816,
	"./SmsClubForm/ru.json": 92226,
	"./SmsConsultForm/en.json": 3345,
	"./SmsConsultForm/ru.json": 94454,
	"./SmsLinkShortReport/en.json": 27043,
	"./SmsLinkShortReport/ru.json": 38403,
	"./SmsLinkShortReportNotify/en.json": 17834,
	"./SmsLinkShortReportNotify/ru.json": 48724,
	"./SmsList/en.json": 77959,
	"./SmsList/ru.json": 79212,
	"./SmsPobedaForm/en.json": 42635,
	"./SmsPobedaForm/ru.json": 82938,
	"./SmsProvider/en.json": 64354,
	"./SmsProvider/ru.json": 93368,
	"./SmsProviders/en.json": 82225,
	"./SmsProviders/ru.json": 79519,
	"./SmsRetailViberForm/en.json": 490,
	"./SmsRetailViberForm/ru.json": 33790,
	"./SmsRetailWhatsappForm/en.json": 6777,
	"./SmsRetailWhatsappForm/ru.json": 1239,
	"./SmsRules/en.json": 71248,
	"./SmsRules/ru.json": 70200,
	"./SmsSend/en.json": 70879,
	"./SmsSend/ru.json": 79965,
	"./SmsSender/en.json": 32261,
	"./SmsSender/ru.json": 69128,
	"./SmsShowWebhook/en.json": 98383,
	"./SmsShowWebhook/ru.json": 7619,
	"./SmsState/en.json": 38867,
	"./SmsState/ru.json": 7201,
	"./SmsTemplate/en.json": 80619,
	"./SmsTemplate/ru.json": 87869,
	"./SmsTemplatePreview/en.json": 71373,
	"./SmsTemplatePreview/ru.json": 1052,
	"./SmsTemplateSelector/en.json": 803,
	"./SmsTemplateSelector/ru.json": 84205,
	"./SmsTemplates/en.json": 55930,
	"./SmsTemplates/ru.json": 58419,
	"./SmsToForm/en.json": 80196,
	"./SmsToForm/ru.json": 88798,
	"./SmsTrafficForm/en.json": 53299,
	"./SmsTrafficForm/ru.json": 12686,
	"./SmsVonageForm/en.json": 12800,
	"./SmsVonageForm/ru.json": 91799,
	"./SmscForm/en.json": 64937,
	"./SmscForm/ru.json": 34835,
	"./SmscGasketForm/en.json": 57392,
	"./SmscGasketForm/ru.json": 56269,
	"./SolutionBotTesterForm/en.json": 21499,
	"./SolutionBotTesterForm/ru.json": 92487,
	"./SolutionForClient/en.json": 70390,
	"./SolutionForClient/ru.json": 4583,
	"./SolutionManager/en.json": 15107,
	"./SolutionManager/ru.json": 92527,
	"./SolutionManagerPopup/en.json": 28719,
	"./SolutionManagerPopup/ru.json": 47402,
	"./SolutionsForClient/en.json": 88762,
	"./SolutionsForClient/ru.json": 11926,
	"./StartTemplates/en.json": 74967,
	"./StartTemplates/ru.json": 9304,
	"./Status/en.json": 37934,
	"./Status/ru.json": 46183,
	"./StatusFilter/en.json": 62781,
	"./StatusFilter/ru.json": 48512,
	"./StatusLine/en.json": 40330,
	"./StatusLine/ru.json": 29665,
	"./StatusTree/en.json": 2241,
	"./StatusTree/ru.json": 69812,
	"./Statuses/en.json": 39787,
	"./Statuses/ru.json": 61601,
	"./StreamTelecomForm/en.json": 57533,
	"./StreamTelecomForm/ru.json": 4399,
	"./Subdivisions/en.json": 89057,
	"./Subdivisions/ru.json": 89808,
	"./SupportContacts/en.json": 42672,
	"./SupportContacts/ru.json": 69520,
	"./SupportDocs/en.json": 3295,
	"./SupportDocs/ru.json": 53173,
	"./SurveyReport/en.json": 50949,
	"./SurveyReport/ru.json": 45426,
	"./TableTdDialogs/en.json": 85720,
	"./TableTdDialogs/ru.json": 79402,
	"./TabsRobotHistory/en.json": 86458,
	"./TabsRobotHistory/ru.json": 48854,
	"./Tags/en.json": 21284,
	"./Tags/ru.json": 46786,
	"./TargetT2Form/en.json": 67038,
	"./TargetT2Form/ru.json": 12082,
	"./TariffMessenger/en.json": 61990,
	"./TariffMessenger/ru.json": 41293,
	"./Tariffs/en.json": 88038,
	"./Tariffs/ru.json": 69884,
	"./TariffsEmail/en.json": 21233,
	"./TariffsEmail/ru.json": 20768,
	"./TariffsSms/en.json": 8107,
	"./TariffsSms/ru.json": 3945,
	"./TariffsSpeech/en.json": 2688,
	"./TariffsSpeech/ru.json": 84807,
	"./TariffsTabs/en.json": 75518,
	"./TariffsTabs/ru.json": 41381,
	"./TelCheckToService/en.json": 7435,
	"./TelCheckToService/ru.json": 53434,
	"./TeleTwoMaskedForm/en.json": 58815,
	"./TeleTwoMaskedForm/ru.json": 40180,
	"./TeleZeroForm/en.json": 2635,
	"./TeleZeroForm/ru.json": 77863,
	"./TelephonyNumbers/en.json": 1725,
	"./TelephonyNumbers/ru.json": 96299,
	"./TelesignForm/en.json": 64670,
	"./TelesignForm/ru.json": 10198,
	"./TemplateBlockSolutions/en.json": 79772,
	"./TemplateBlockSolutions/ru.json": 30384,
	"./TemplateForm/en.json": 91568,
	"./TemplateForm/ru.json": 94960,
	"./TemplateItem/en.json": 81276,
	"./TemplateItem/ru.json": 6405,
	"./TemplateList/en.json": 12835,
	"./TemplateList/ru.json": 29160,
	"./TemplateNew/en.json": 43516,
	"./TemplateNew/ru.json": 36746,
	"./TemplateRowForm/en.json": 55605,
	"./TemplateRowForm/ru.json": 31621,
	"./TemplateSizeIndicator/en.json": 54335,
	"./TemplateSizeIndicator/ru.json": 34261,
	"./TeraSmsForm/en.json": 57995,
	"./TeraSmsForm/ru.json": 66156,
	"./Test/en.json": 89518,
	"./Test/ru.json": 41137,
	"./TestGradesReport/en.json": 19103,
	"./TestGradesReport/ru.json": 63226,
	"./TestIntent/en.json": 77114,
	"./TestIntent/ru.json": 66222,
	"./TestQuestion/en.json": 72007,
	"./TestQuestion/ru.json": 46199,
	"./TestQuestions/en.json": 91151,
	"./TestQuestions/ru.json": 46311,
	"./TestQuestionsReport/en.json": 43960,
	"./TestQuestionsReport/ru.json": 87131,
	"./Tests/en.json": 37874,
	"./Tests/ru.json": 49950,
	"./TextForm/en.json": 92419,
	"./TextForm/ru.json": 36160,
	"./TimeEstimator/en.json": 70128,
	"./TimeEstimator/ru.json": 24570,
	"./TimezoneSelect/en.json": 89282,
	"./TimezoneSelect/ru.json": 68368,
	"./TopyingForm/en.json": 75519,
	"./TopyingForm/ru.json": 83578,
	"./Traffic/en.json": 73699,
	"./Traffic/ru.json": 14526,
	"./Traffics/en.json": 95018,
	"./Traffics/ru.json": 43657,
	"./Transactions/en.json": 42456,
	"./Transactions/ru.json": 94283,
	"./TtsForm/en.json": 71910,
	"./TtsForm/ru.json": 86591,
	"./TtsTextEdit/en.json": 54559,
	"./TtsTextEdit/ru.json": 19649,
	"./TurboSmsForm/en.json": 16097,
	"./TurboSmsForm/ru.json": 53584,
	"./TwentyThreeTelecomForm/en.json": 8124,
	"./TwentyThreeTelecomForm/ru.json": 65453,
	"./Unload/en.json": 51571,
	"./Unload/ru.json": 79649,
	"./UnloadSelector/en.json": 31774,
	"./UnloadSelector/ru.json": 41117,
	"./Unloads/en.json": 95493,
	"./Unloads/ru.json": 92716,
	"./Unpacked/en.json": 45729,
	"./Unpacked/ru.json": 53479,
	"./UploadDetailsModal/en.json": 27627,
	"./UploadDetailsModal/ru.json": 39329,
	"./UsedPhoneNumbers/en.json": 7456,
	"./UsedPhoneNumbers/ru.json": 6915,
	"./User/en.json": 87906,
	"./User/ru.json": 97460,
	"./UserForm/en.json": 35105,
	"./UserForm/ru.json": 29505,
	"./UserFormAnalytics/en.json": 33220,
	"./UserFormAnalytics/ru.json": 16732,
	"./UserForms/en.json": 83777,
	"./UserForms/ru.json": 60688,
	"./UserStatusLog/en.json": 44593,
	"./UserStatusLog/ru.json": 88371,
	"./UserTests/en.json": 62071,
	"./UserTests/ru.json": 28437,
	"./VacotelForm/en.json": 81058,
	"./VacotelForm/ru.json": 79056,
	"./VariableSelect/en.json": 40402,
	"./VariableSelect/ru.json": 50282,
	"./VideoForm/en.json": 36020,
	"./VideoForm/ru.json": 11613,
	"./VideoItem/en.json": 79960,
	"./VideoItem/ru.json": 87060,
	"./VvchRecrutingReport/en.json": 57043,
	"./VvchRecrutingReport/ru.json": 61276,
	"./VxTelecomForm/en.json": 22015,
	"./VxTelecomForm/ru.json": 94584,
	"./WaTplSelectBox/en.json": 45920,
	"./WaTplSelectBox/ru.json": 54127,
	"./WebinarCourse/en.json": 88542,
	"./WebinarCourse/ru.json": 39881,
	"./WebinarCourseItem/en.json": 43357,
	"./WebinarCourseItem/ru.json": 98183,
	"./Webinars/en.json": 27000,
	"./Webinars/ru.json": 70731,
	"./WeightAdjusting/en.json": 9467,
	"./WeightAdjusting/ru.json": 39590,
	"./WeightAdjustingChart/en.json": 35496,
	"./WeightAdjustingChart/ru.json": 18016,
	"./WhoPacked/en.json": 89950,
	"./WhoPacked/ru.json": 58538,
	"./WholesaleSalesReport/en.json": 13100,
	"./WholesaleSalesReport/ru.json": 63747,
	"./Wholesaler/OptOrderColumns/en.json": 93055,
	"./Wholesaler/OptOrderColumns/ru.json": 72125,
	"./WholesalerAcceptance/en.json": 50807,
	"./WholesalerAcceptance/ru.json": 9907,
	"./WholesalerClient/en.json": 24543,
	"./WholesalerClient/ru.json": 14136,
	"./WholesalerClients/en.json": 7717,
	"./WholesalerClients/ru.json": 93782,
	"./WholesalerPurchases/en.json": 63870,
	"./WholesalerPurchases/ru.json": 11726,
	"./WholesalerSaleStatus/en.json": 51431,
	"./WholesalerSaleStatus/ru.json": 77792,
	"./WholesalerSaleStatuses/en.json": 50594,
	"./WholesalerSaleStatuses/ru.json": 41307,
	"./WholesalerService/en.json": 62473,
	"./WholesalerService/ru.json": 44861,
	"./WholesalerServices/en.json": 59548,
	"./WholesalerServices/ru.json": 68453,
	"./WholesalerStock/en.json": 15748,
	"./WholesalerStock/ru.json": 85173,
	"./WholesalerStocks/en.json": 26834,
	"./WholesalerStocks/ru.json": 64710,
	"./WholesalerUnload/en.json": 93247,
	"./WholesalerUnload/ru.json": 89474,
	"./WholesalerUnloads/en.json": 60590,
	"./WholesalerUnloads/ru.json": 32381,
	"./WmcMix/en.json": 23934,
	"./WmcMix/ru.json": 80996,
	"./WtcForm/en.json": 16949,
	"./WtcForm/ru.json": 88353,
	"./ZazuMediaForm/en.json": 69450,
	"./ZazuMediaForm/ru.json": 24257,
	"./ZorraForm/en.json": 59553,
	"./ZorraForm/ru.json": 99274,
	"./bot-block/en.json": 48254,
	"./bot-block/ru.json": 91418,
	"./bpm_actions/en.json": 73895,
	"./bpm_actions/ru.json": 60032,
	"./cdp_filter_operations/en.json": 86059,
	"./cdp_filter_operations/ru.json": 30552,
	"./conditional_operators_mix/en.json": 84151,
	"./conditional_operators_mix/ru.json": 82507,
	"./consolidated_report/en.json": 5930,
	"./consolidated_report/ru.json": 37191,
	"./file_utilities/en.json": 61050,
	"./file_utilities/ru.json": 43753,
	"./fines_mix/en.json": 58217,
	"./fines_mix/ru.json": 63016,
	"./full/en.json": 77682,
	"./full/ru.json": 99241,
	"./http/en.json": 27790,
	"./http/ru.json": 39163,
	"./intent-menu/en.json": 60019,
	"./intent-menu/ru.json": 24695,
	"./intents/en.json": 43237,
	"./intents/ru.json": 50816,
	"./llm_settings/en.json": 35158,
	"./llm_settings/ru.json": 7712,
	"./nested_filter_operations/en.json": 34475,
	"./nested_filter_operations/ru.json": 26959,
	"./order_validators_mix/en.json": 73308,
	"./order_validators_mix/ru.json": 84505,
	"./profile/en.json": 56828,
	"./profile/ru.json": 69227,
	"./robot/en.json": 25253,
	"./robot/ru.json": 93756,
	"./screen-action/en.json": 78296,
	"./screen-action/ru.json": 44328,
	"./screen-condition/en.json": 27493,
	"./screen-condition/ru.json": 76016,
	"./screen/en.json": 17868,
	"./screen/ru.json": 67695,
	"./tester/en.json": 89375,
	"./tester/ru.json": 43116,
	"./updateOrderInfoForm/en.json": 21211,
	"./updateOrderInfoForm/ru.json": 68013,
	"./user-block/en.json": 70973,
	"./user-block/ru.json": 51845,
	"./variables/en.json": 67703,
	"./variables/ru.json": 71389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45748;